import { gql } from 'Utils/apolloClient'

const InstallmentDataFragment = gql`
  fragment installmentData on Installment {
    camperExtras {
      amount
      display
    }
    campground {
      fullAddress
      isCountryUs
      name
      phone
      slug
    }
    canPay
    canRefund
    canReplace
    canSend
    createdAt
    daysForDue
    disableSendNotification
    dueAt
    dueOn
    hasLateFee
    hasLateFeeConfig
    hasPayment
    hasPaymentMethodStripeFailed
    hasPendingRefunds
    hasPricing
    id
    installments {
      dueOn
      id
      number
      paidAt
      sentAt
      state
      total {
        display
        displayWithCode
      }
    }
    installmentsAll {
      dueOn
      id
      number
      paidAt
      processingAt
      sentAt
      state
      total {
        display
        displayWithCode
      }
    }
    installmentsCount
    installmentsStateOpen {
      dueOn
      id
      number
      paidAt
      processingAt
      sentAt
      state
      total {
        display
        displayWithCode
      }
    }
    isEditable
    isEditableOnOverdue
    isNotPayableYet
    isProcessing
    isSendToGuest
    items {
      category
      data {
        kws
        meterEnd
        meterStart
        priceKw
      }
      id
      meterRead {
        unit
        readDate
      }
      name
      price {
        amount
        display
      }
      reservation {
        itemsDiscount {
          name
          nameDescription
        }
      }
      isFee
      isNameReadOnly
      subtotal {
        amount
        display
      }
      taxRate
      total {
        amount
        display
      }
      units
    }
    links {
      installmentNextToPayPath
    }
    isExternallyPaid
    isPaid
    isPaymentInstallment
    lateFeeAmount {
      display
      amount
    }
    events {
      id
      changesHumanized
      data {
        installmentReplacedId
        itemChanges {
          name
          total
        }
        itemId
        itemName
        itemTotal
        refundId
        refundMemo
        refundSubtotal
      }
      name
      occurredAt
    }
    maxRefundableCamperFee
    maxRefundableCamperProcessingFee
    maxRefundableGrandTotal
    name
    number
    overdueAt
    paidAt
    paymentMethod {
      ... on PaymentMethodStripeAch {
        accountHolder
        brand
        isVerified
        lastFour
      }
      ... on PaymentMethodStripeCard {
        brandIconKey
        lastFour
      }
      __typename
    }
    paymentSource
    platformFee {
      amount
      display
    }
    hasPreviousPendingToPay
    pricing {
      camperFee {
        amount
        display
      }
      camperFeeMaxToRefund {
        amount
        display
      }
      camperProcessingFeeMaxToRefund {
        amount
        display
      }
      camperProcessingFee {
        display
      }
      grandTotalMax {
        amount
        display
      }
      isTaxIncluded
      reversePayoutAmountMax {
        amount
        display
      }
      subtotal {
        display
      }
      subtotalMin {
        display
        amount
      }
      taxConfig {
        isIncluded
        rate
        rateValue
        taxName
      }
      tax {
        display
      }
    }
    processingFeeTotal {
      display
    }
    reservation {
      canReversePayout
      stripeCardOnFile {
        ... on PaymentMethodStripeAch {
          accountHolder
          brand
          id
          isVerified
          lastFour
        }
        ... on PaymentMethodStripeCard {
          id
          brand
          brandIconKey
          lastFour
        }
        __typename
      }
      email
      formattedFrom
      formattedTo
      from
      hasBalance
      id
      isAutopay
      isBuilder
      isInvoiceFirstPayment
      isPending
      isRequest
      itemsExtras {
        name
        units
      }
      name
      phone {
        number
      }
      pricing {
        isTaxIncluded
        camperFee {
          amount
          display
        }
        camperProcessingFee {
          display
        }
        camperTotal {
          displayWithCode
        }
        subtotal {
          display
        }
        tax {
          display
        }
      }
      site {
        id
        name
      }
      state
      to
    }
    refund {
      id
      source
      state
      total {
        display
      }
    }
    refundExternal {
      id
      source
      total {
        display
      }
    }
    refunds {
      createdAt
      id
      reasonText
      state
      subtotal
      total {
        display
      }
    }
    refundStatus
    refundStatusMessage
    scheduledAt
    scheduledOn
    scheduleTemplate {
      id
      isActive
      hasPaymentMethodAuto
      hasPaymentMethodStripeFailed
      paymentMethodAuto {
        ... on PaymentMethodStripeAch {
          accountHolder
          brand
          isVerified
          lastFour
        }
        ... on PaymentMethodStripeCard {
          brand
          brandIconKey
          expDate
          lastFour
        }
        __typename
      }
    }
    sentAt
    showUnsentReplaced
    state
    subtotal
    tax {
      amount
      display
    }
    termsOfService
    total {
      amount
      display
      displayWithCode
    }
    totalBeforeProcessing {
      amount
      display
    }
    totalRefunded {
      display
    }
    usedFor
    uuid
    voidedAt
  }`

export default InstallmentDataFragment
